import { useState } from "react";
import { SketchPicker } from "react-color";

interface ColorPickerProps {
  color: string;
  onChange: (color: string) => void;
}

const ColorPicker: React.FC<ColorPickerProps> = ({ color, onChange }) => {
  const [showPicker, setShowPicker] = useState(false);

  return (
    <div className=" inline-block">
      <div
        className="w-10 h-10 border-2 border-gray-300 rounded cursor-pointer"
        style={{ backgroundColor: color }}
        onClick={() => setShowPicker(!showPicker)}
      ></div>

      {showPicker && (
        <div className="absolute z-10 mt-2 shadow-lg">
          <SketchPicker
            color={color}
            onChange={(updatedColor:any) => onChange(updatedColor.hex)}
          />
        </div>
      )}
    </div>
  );
};

export default ColorPicker;
